<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import "@/assets/styles/bootstrap-reboot.min.css";
import "@/assets/styles/bootstrap-grid.min.css";

import "aos/dist/aos.css";
import AOS from "aos";

import { mapActions } from "vuex";

export default {
  name: "App",
  components: {},
  metaInfo: {
    title: "Главная страница",
    // all titles will be injected into this template
    titleTemplate: "%s - TOO СК-Грант",
    meta: [
      {
        vmid: "description",
        name: "description",
        content: "Лидер производства щебня в Северо-Казахстанской области"
      },
      {
        property: "og:title",
        content: "Главная страница - TOO СК-Грант",
        vmid: "og:title"
      },
      {
        property: "og:description",
        content: "Лидер производства щебня в Северо-Казахстанской области",
        vmid: "og:description"
      }
    ]
  },
  mounted() {
    AOS.init();

    this.getPriceList();
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions("pricelist", ["getPriceList"])
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i&subset=cyrillic,cyrillic-ext");

@import "@/assets/styles/settings.scss";
@import "@/assets/styles/main.scss";

#app {
  font-family: $font-stack;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: $black-color;
  color: $white-color;
  font-size: $main-font-size;
  line-height: 1.3;
  min-height: 100vh;
  scroll-behavior: smooth;
  overflow: hidden;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
